exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".f74ev{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.f74ev h2{display:inline-block;font-size:1.2em;margin:0}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"orange": "#ff4e32",
	"sick": "#673ab7",
	"vacation": "#cddc39",
	"holiday": "#4caf50",
	"balanceHeader": "f74ev"
};